import { AiOutlineStar,AiFillStar } from 'react-icons/ai'

import styles from './AppRatingModalFormStars.module.scss';

export default function AppRatingModalFormStars({ value, onChange }) {
  return [...Array(5).keys()].map((_, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <button className={styles.btn} key={i} onClick={() => onChange(i + 1)}>
      {value > i ? (
        <AiFillStar className={styles.star}/>
      ) : (
        <AiOutlineStar className={styles.star}/>
      )}
    </button>
  ));
}
